import type { SVGProps } from 'react'

interface AtlanticForestBiomeIconProps extends SVGProps<SVGSVGElement> {}

export function AtlanticForestBiomeIcon(props: AtlanticForestBiomeIconProps) {
  return (
    <svg
      width={30}
      height={36}
      viewBox="0 0 30 36"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 36v-8.52c-.94.34-1.94.52-3 .52-5 0-9-4-9-9 0-2.54 1-4.82 2.72-6.46A9.027 9.027 0 012 9c0-5 4-9 9-9 3.12 0 5.88 1.6 7.5 4h.5a11 11 0 010 22c-1 0-2-.14-3-.42V36h-4z"
        fill="currentColor"
      />
    </svg>
  )
}
